import { GuardedDeletionService } from 'projects/orchestrator/src/lib/services/guarded-deletion.service';
import { Component, inject } from '@angular/core';
import { PipelinePlannedPlantationService } from '../proxy/operational/controllers';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PipelinePlannedPlantationCreateDto,
  PipelinePlannedPlantationUpdateDto,
} from '../proxy/operational/dtos/pipeline-planned-plantation';
import { PIPELINEPLANNEDPLANTATION_CONFIG, PIPELINEPLANNEDPLANTATION_FIELDS } from './pipeline-planned-plantation.config';
import { BaseHierarchicalCrudComponent, GenericForm, ICrudService, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';
import { PipelinePlannedPlantationPlanningOrchestratorService } from 'orchestrator/proxy';
import {
  GetPipelinePlannedPlantationProjectionListInputDto,
  PipelinePlannedPlantationProjectionDto,
  PipelinePlannedPlantationProjectionExcelDownloadDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/pipeline-planned-plantations/models';

@Component({
  selector: 'app-pipeline-planned-plantation',
  imports: [CommonModule, GenericForm, ZnHierarchicalViewComponent],
  providers: [ListService, PipelinePlannedPlantationService, ConfirmationService],
  templateUrl: './pipeline-planned-plantation.html',
  styleUrl: './pipeline-planned-plantation.scss',
})
export class PipelinePlannedPlantation extends BaseHierarchicalCrudComponent<
  PipelinePlannedPlantationProjectionDto,
  PipelinePlannedPlantationCreateDto,
  PipelinePlannedPlantationUpdateDto,
  PipelinePlannedPlantationProjectionExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  operationalService = inject(PipelinePlannedPlantationService);
  orchestratorService = inject(PipelinePlannedPlantationPlanningOrchestratorService);

  service: ICrudService<
    PipelinePlannedPlantationProjectionDto,
    PipelinePlannedPlantationCreateDto,
    PipelinePlannedPlantationUpdateDto,
    PipelinePlannedPlantationProjectionExcelDownloadDto
  > = {
    create: input => this.operationalService.create(input),
    update: (id, input) => this.operationalService.update(id, input),
    deleteByIds: ids => this.guardedDeletion.deleteByIds('pipeline-planned-plantations', ids),
    getList: (query: GetPipelinePlannedPlantationProjectionListInputDto) =>
      this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(
      this.orchestratorService,
      'pipelinePlannedPlantationId',
    ),
  };
  config = PIPELINEPLANNEDPLANTATION_CONFIG;
  fields = PIPELINEPLANNEDPLANTATION_FIELDS;

  protected prepareUpdateDto(
    data: any,
    selected: PipelinePlannedPlantationProjectionDto,
  ): PipelinePlannedPlantationUpdateDto {
    const fromDataOrSelected = <T>(key: string, fallback: T) =>
      data[key] === undefined ? fallback : data[key];

    return {
      pipelinePlannedPlantationHeaderId: fromDataOrSelected(
        'pipelinePlannedPlantationHeaderId',
        selected.pipelinePlannedPlantationHeaderId ?? 0,
      ),
      pipelineStandId: fromDataOrSelected(
        'pipelineStandId',
        selected.pipelineStandId ?? 0,
      ),
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PipelinePlannedPlantation';
  }
}
